import React from "react";
import { useTranslation } from "@/hooks/useTranslation";
import TextInput from "../ui/input/text-input";
import { cn } from "@/lib/utils";

export default function DiscountCodeInput({
  discountCode,
  setDiscountCode,
  onApplyDiscount,
  discountLoading,
  discountError,
  setDiscountError,
  disabled,
}: {
  discountCode: string;
  setDiscountCode: (value: string) => void;
  onApplyDiscount: () => void;
  discountLoading: boolean;
  discountError: string | undefined;
  setDiscountError: (value: string | undefined) => void;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="relative">
      {discountError && (
        <p className="absolute top-0 left-0 text-sm text-red-500">
          {discountError}
        </p>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onApplyDiscount();
        }}
        className="mb-4 flex flex-row space-x-2"
      >
        <TextInput
          label={t("discount_code")}
          containerStyles="flex w-full flex-col *:grow"
          inputStyles="h-full! min-h-input w-full bg-white ring-1 ring-gray-200 ring-inset"
          handleInputChange={(value) => {
            setDiscountCode(value.replace(/\s/g, ""));
          }}
          value={discountCode}
          setValue={setDiscountCode}
          error={discountError}
          onBlur={() => {
            if (!discountCode.length) {
              setDiscountError(undefined);
            }
          }}
        />
        <button
          disabled={disabled}
          className={cn(
            "min-h-input flex max-w-[140px] min-w-[74px] flex-shrink-0 items-center justify-center rounded px-4 py-2 text-sm font-semibold transition-colors",
            disabled
              ? "cursor-not-allowed bg-white text-gray-600 opacity-50 ring-1 ring-gray-200 ring-inset"
              : cn(
                  "hover:opacity-90",
                  discountCode.length &&
                    "bg-brand-primary text-brand-primary-text",
                ),
          )}
          type="submit"
        >
          {discountLoading ? (
            <div className="h-5 w-5 animate-spin rounded-full border-4 border-t-4 border-white border-t-transparent"></div>
          ) : (
            t("apply")
          )}
        </button>
      </form>
    </div>
  );
}
